import { GroupCheckIcon } from 'components/Icons/GroupCheckIcon'
import { IoCloseSharp } from 'react-icons/io5'
import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import {
    Body,
    ButtonAction,
    ButtonsContainer,
    dialogPanel,
    dialogTitle
} from './styles'

interface GroupTreatmentModalProps {
    isOpen: boolean
    handleCloseModal: () => void
    handleIndividualTreatment: () => void
    handleGroupTreatment: () => void
    groupCount?: number
}

const textPresentation = (value: number) => (
    value == 1 ? " notificação" : " notificações"
)

const totalNotifications = (notifications: number): number => {
    let total = 50
    // Mínimo de 2 notificações para formar grupo
    if (notifications < 2) 
        return 2;

    if (notifications < total) 
        return notifications;

    return total;
};

const GroupTreatmentModal: React.FC<GroupTreatmentModalProps> = ({
    isOpen,
    handleCloseModal,
    handleIndividualTreatment,
    handleGroupTreatment,
    groupCount = 2
}) => {
    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-GroupTreatment"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <Dialog.Title
                                        as="h3"
                                        className={dialogTitle}
                                    >
                                        <div className="flex flex-col items-center w-full">
                                            <GroupCheckIcon />
                                            <p className="text-[#0ABB89] text-xl font-semibold mt-2 mb-4">
                                                Tratamento em grupo disponível!
                                            </p>
                                        </div>
                                        <IoCloseSharp
                                            onClick={handleCloseModal}
                                            className="text-blueTheme h-8 w-8 p-1 cursor-pointer"
                                        />
                                    </Dialog.Title>
                                    <Body>
                                        <div className="text-base text-gray-700 mb-8">
                                            <div>Esta notificação está disponível para ser tratada</div>
                                            <div>em grupo com mais{' '}
                                                <span className="font-semibold text-blueTheme">
                                                    {totalNotifications(groupCount) - 1}
                                                </span> 
                                                {textPresentation(totalNotifications(groupCount) - 1)}.
                                            </div>
                                        </div>
                                        <p className="text-base text-gray-700 mb-10">
                                            Como deseja prosseguir?
                                        </p>

                                        <ButtonsContainer>
                                            <ButtonAction
                                                onClick={handleIndividualTreatment}
                                                type="button"
                                                className="text-blueTheme text-sm"
                                            >
                                                Tratar individualmente
                                            </ButtonAction>

                                            <ButtonAction
                                                onClick={handleGroupTreatment}
                                                className="bg-blueTheme text-white text-sm"
                                            >
                                                Seguir com o tratamento em grupo
                                            </ButtonAction>
                                        </ButtonsContainer>
                                    </Body>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export { GroupTreatmentModal } 